import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["style", "css", "className", "as", "asChild", "viewBox", "size", "color", "verticalAlign", "title", "children"];
import React from "react";
import { BaseIcon } from "./styled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Icon(_ref) {
  var style = _ref.style,
    css = _ref.css,
    className = _ref.className,
    as = _ref.as,
    asChild = _ref.asChild,
    _ref$viewBox = _ref.viewBox,
    viewBox = _ref$viewBox === void 0 ? "0 0 24 24" : _ref$viewBox,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "md" : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "lowContrast" : _ref$color,
    _ref$verticalAlign = _ref.verticalAlign,
    verticalAlign = _ref$verticalAlign === void 0 ? "middle" : _ref$verticalAlign,
    title = _ref.title,
    children = _ref.children,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(BaseIcon, _extends({
    viewBox: viewBox,
    color: color,
    size: size,
    css: {
      verticalAlign: verticalAlign
    }
    //  If the user passes a title, we use that to describe the icon
    ,
    "aria-hidden": title ? "false" : "true"
    // If the user passes a title, we tell screen readers that the icon's role is as an image
    ,
    role: title && "img"
  }, restProps, {
    children: [title && /*#__PURE__*/_jsx("title", {
      children: title
    }), children]
  }));
}
export default Icon;